import { applyEncodingDecodingToAllRoutes } from './routesParamsEncoding';

const fileRoutes = [
  {
    name: 'files',
    path: '/files',
    children: [{ name: 'directory', path: '/*basepath' }],
  },
  {
    name: 'file',
    path: '/file/*basepath?:viaPreview',
  },
];

const sharedFileRoutes = [
    { name: 'file', path: '/:sharedFileId<[\\w\\d]+={0,2}>?:ini?:v' },
];

const projectRoutes = [
  ...fileRoutes,
  { name: 'version', path: '/v/:contributionId', children: fileRoutes },
  { name: 'contribution', path: '/contributions/:contributionId' },
  { name: 'conflicts', path: '/conflicts' },
  { name: 'issues', path: '/tasks' },
  { name: 'issue', path: '/tasks/:issueSlug<.*>' },
  {
    name: 'settings',
    path: '/settings',
    children: [
      { name: 'teams', path: '/collaborators' },
      { name: 'general', path: '/general' },
      { name: 'admin', path: '/admin' },
      { name: 'fileSync', path: '/fileSync' },
    ],
  },
];

const storyRoutes = [{ name: 'edit', path: '/edit' }];

const homeRoutes = [
  // websites
  {
    name: 'community',
    path: 'community',
    forwardTo: 'home.community.featured',
    children: [
      { name: 'article', path: '/social-gets-productive' },
      { name: 'featured', path: '/featured' },
      { name: 'topics', path: '/topics' },
      { name: 'projects', path: '/projects' },
      { name: 'tasks', path: '/tasks' },
    ],
  },
  { name: 'marketplace', path: 'marketplace' },
  {
    name: 'company',
    path: 'company',
    children: [
      { name: 'about', path: '/about' },
      { name: 'story', path: '/story' },
      {
        name: 'careers',
        path: '/careers',
        children: [{ name: 'position', path: '/:position' }],
      },
    ],
  },
  { name: 'pricing', path: 'pricing' },
  { name: 'privacy', path: 'privacy' },
  { name: 'cookies', path: 'cookies' },
  { name: 'terms', path: 'terms' },
  { name: 'features', path: 'features' }, // figure out what to do.
  { name: 'formats', path: 'file-formats' }, // figure out what to do.
  // platform
  {
    name: 'contribute',
    path: 'contribute',
    forwardTo: 'home.community.featured',
    children: [
      {
        name: 'projects',
        path: '/projects',
        forwardTo: 'home.community.projects',
      },
      { name: 'issues', path: '/tasks', forwardTo: 'home.community.tasks' },
    ],
  },
  {
    name: 'connect',
    path: 'connect',
    children: [
      { name: 'conversations', path: '/conversations' },
      {
        name: 'members',
        path: '/members',
        forwardTo: 'home.community.members',
      },
      { name: 'organisations', path: '/organisations' },
    ],
  },
  {
    name: 'discover',
    path: 'discover',
    children: [
      { name: 'topics', path: '/topics', forwardTo: 'home.community.topics' },
      { name: 'stories', path: '/stories' },
    ],
  },
  { name: 'home', path: 'home' }, // always maps to "logged out" landing page.
  { name: 'notifications', path: 'notifications' },
  { name: 'gateway', path: 'gateway?:utoken&:next' },
  { name: 'invite', path: 'invite/:inviteId/:referrerUserId/:token&:next' },
  { name: 'signUp', path: 'sign-up?:next?:id?:p' },
  { name: 'signUpOrganisation', path: 'sign-up-organisation?:next?:id' },
  { name: 'signUpManufacturer', path: 'sign-up-manufacturer' },
  { name: 'signIn', path: 'sign-in?:next' },

  {
    name: 'newPassword',
    path: 'new-password/:username<@[^/?]+>/:expiry/:hmac',
  },
  { name: 'newStory', path: 'new-story' },
  { name: 'newProject', path: 'new-project' },
  { name: 'importProject', path: 'import-project' },
  { name: 'newInitiative', path: 'create-team' },
  { name: 'search', path: 'search?:q' },
  { name: 'redirect', path: 'redirect' },
];

const manufacturingPortal = [
  { name: 'rfq', path: '/rfqs/:rfqId' },
  { name: 'quote', path: '/quotes/:quoteId' },
  { name: 'order', path: '/order/:orderId' },
];

const roleSensitiveWorkspaceRoutes = [
  {
    name: 'rfqs',
    path: '/rfqs?:p&:order&:sort&:filters&:intermediator',
  },
  {
    name: 'quotes',
    path: '/quotes',
  },
  { name: 'orders', path: '/orders' },
];

const routes = [
  { name: 'home', path: '/', children: homeRoutes },
  {
    name: 'profile',
    path: '/:profile<@[^/?]+>',
    children: [
      { name: 'story', path: '/stories/:slug', children: storyRoutes },
      { name: 'collection', path: '/collection/:slug' },
      { name: 'shared', path: '/files', children: sharedFileRoutes },
      { name: 'deprecatedSharedRoute', path: '/shared/:sharedFileId<[\\w\\d]+={0,2}>?:ini?:v', forwardTo: 'profile.shared.file' },
      { name: 'project', path: '/:slug<[^/?]+>', children: projectRoutes },
      { name: 'invitations', path: '/invitations' },
      { name: 'projects', path: '/' },
      { name: 'stories', path: '/stories' },
      { name: 'threads', path: '/threads' },
      {
        name: 'collections',
        path: '/collections',
        // children: [
        //   {
        //     name: 'collection',
        //     path: '/:slug',
        //   },
        // ],
      },
    ],
  },
  {
    name: 'initiative',
    path: '/:initiative<\\+[^/?]+>?:thread',
    children: [
      {
        name: 'services',
        path: '/services',
        children: [
          {
            name: 'editFabrication',
            path: '/edit-fabrication-services',
          },
        ],
      },
      { name: 'projects', path: '/' },
      { name: 'stories', path: '/stories' },
      { name: 'story', path: '/stories/:slug', children: storyRoutes },
      { name: 'collection', path: '/collections/:slug' },
      { name: 'shared', path: '/files', children: sharedFileRoutes },
      { name: 'deprecatedSharedRoute', path: '/shared/:sharedFileId<[\\w\\d]+={0,2}>?:ini?:v', forwardTo: 'initiative.shared.file' },
      { name: 'project', path: '/:slug<[^/?]+>', children: projectRoutes },
      {
        name: 'forum',
        path: '/forum',
        children: [
          {
            name: 'categorySlug',
            path: '/category/:categoryId/:categorySlug',
          },
          { name: 'category', path: '/category/:categoryId' },
          { name: 'threadSlug', path: '/thread/:threadId/:threadSlug' },
          { name: 'thread', path: '/thread/:threadId' },
        ],
      },
    ],
  },
  {
    name: 'channel',
    path: '/topic/:channel',
    children: [
      {
        name: 'stories',
        path: '/stories',
      },
      {
        name: 'threads',
        path: '/threads',
      },
      {
        name: 'collections',
        path: '/collections',
      },
      {
        name: 'settings',
        path: '/settings',
        children: [
          { name: 'general', path: '/general' },
          { name: 'teams', path: '/teams' },
        ],
      },
    ],
  },
  {
    name: 'manufacturing',
    path: '/manufacturers',
    children: [{ name: 'results', path: '/results?pc&mc&p&m' }],
  },
  {
    name: 'viewer',
    path: '/viewer/:fileID<[\\w\\d]+={0,2}>?:filename?:isClassicViewer',
  },
  ...manufacturingPortal,
  { name: 'deprecatedRfqRoute', path: '/rfq/:rfqId', forwardTo: 'rfq' },
  {
    name: 'intermediator',
    path: '/intermediator',
    children: manufacturingPortal,
  },
  { name: 'deprecatedIntermediatorRfqRoute', path: '/intermediator/rfq/:rfqId', forwardTo: 'intermediator.rfq' },
  {
    name: 'manufacturer',
    path: '/manufacturer/:manufacturerId',
    children: manufacturingPortal,
  },
  {
    name: 'workspace',
    path: '/workspace/:spacePath<[^/?]+>',
    children: [
      { name: 'spaceProjects', path: '/projects' },
      { name: 'spaceFiles', path: '/files' },
      { name: 'share-file', path: '/upload-file' },
      {
        name: 'make-part',
        path: '/make-part',
        children: [
          { name: 'file', path: '/:sharedFileId<[\\w\\d]+={0,2}>?:ini?:v' },
        ],
      },
      { name: 'sharedWithProjects', path: '/shared-with-projects' },
      { name: 'sharedWithFiles', path: '/shared-with-files' },
      ...roleSensitiveWorkspaceRoutes,
      {
        name: 'intermediator',
        path: '/intermediator',
        children: roleSensitiveWorkspaceRoutes,
        forwardTo: 'workspace',
      },
      {
        name: 'manufacturer',
        path: '/manufacturer/:manufacturerId',
        children: roleSensitiveWorkspaceRoutes,
        forwardTo: 'workspace',
      },
      {
        name: 'spaceSettings',
        path: '/settings',
        children: [
          { name: 'teams', path: '/teams' },
          { name: 'billing', path: '/billing' },
          { name: 'account', path: '/account' },
          { name: 'notifications', path: '/notifications' },
        ],
      },
      { name: 'upgrade', path: '/upgrade' },
      { name: 'upgradePlan', path: '/upgrade-plan' },
    ],
  },
  {
    name: 'new-quote',
    path: '/new-quote/:customerSlug<[@|+]{1}[^\\/?]+>',
  },
  {
    name: 'onboarding',
    path: '/onboarding',
    children: [
      { name: 'choosePlan', path: '/choose-plan' },
      {
        name: 'confirmProfile',
        path: '/confirm-profile',
      },
      {
        name: 'checkEmail',
        path: '/check-email',
      },
      {
        name: 'subscription',
        path: '/subscription',
        children: [
          { name: 'individual', path: '/individual' },
          { name: 'company', path: '/company' },
        ],
      },
    ],
  },
];

// NOTE(david): We inject encodeParams and decodeParams to provide custom encoding.
// See PR for more details: https://github.com/wikifactory/alpha/pull/6389
applyEncodingDecodingToAllRoutes(routes);

export { routes };

if (ENV_NAME !== 'production') {
  routes.push({ name: 'test', path: '/test' });
}
